import { useContext } from "react";
import { Field, Form, Formik } from "formik";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import ImageUpload from "components/ImageUpload";
import { GoogleMaps } from "components/GoogleMaps";
import ResetAndSubmit from "components/ResetAndSubmit";
import * as Yup from "yup";
import { AppContext } from "state";
import { getImageValidationSchema } from "constants/validationSchemas";
import FormWrapper from "components/FormWrapper";
import FotorImageUpload from "components/ImageUpload/FotorImageUpload";

const initialValues = {
  NAME: "",
  LOGO: "",
  EMAIL: "",
  SECONDARY_EMAIL: "",
  // MOBILE: "",
  COUNTRY_CODE: "",
  GOOGLE_MAP_POSITION_NAME: "",
  DOMAIN_NAME: "",
  GOOGLE_MAP_POSITION: "",
  INSTITUTE_TYPE: "",
  BOARD_TYPE: "",
  ADDON_PROGRAMS: [],
  FOUNDING_DATE: "",
  INSTRUCTION_MEDIUM: [],
  GRADE_LEVELS: [],
  TOTAL_STUDENTS_COUNT: "",
  TOTAL_FACULTY_COUNT: "",
};

const validationSchema = Yup.object({
  NAME: Yup.string().required("Institute name is Required"),
  EMAIL: Yup.string().required("Institute email is Required"),
  // SECONDARY_EMAIL: Yup.string().required("Institute secondary email is Required"),
  // MOBILE: Yup.string().required("Institute mobile is Required").matches(/^\d+$/, 'Mobile number must contain only digits'),
  TOTAL_STUDENTS_COUNT: Yup.string().required("Total Students Count is Required").matches(/^\d+$/, 'Student Count must contain only digits'),
  TOTAL_FACULTY_COUNT: Yup.string().required("Total Faculty Count is Required").matches(/^\d+$/, 'Faculty Count must contain only digits'),
  // COUNTRY_CODE: Yup.string().required("Institute country code is Required"),
  LOGO: getImageValidationSchema("Institute logo is Required"),
  // GOOGLE_MAP_POSITION_NAME: Yup.string().required("Institute location is Required"),
  GOOGLE_MAP_POSITION: Yup.object().required("Required"),
  INSTITUTE_TYPE: Yup.string().required(" Institute type is Required"),
  DOMAIN_NAME: Yup.string().required(" Domain is Required"),
  BOARD_TYPE: Yup.string().required("Board type is Required"),
  ADDON_PROGRAMS: Yup.array().min(1, "Add on programs is Required"),
  FOUNDING_DATE: Yup.string().required("Institute founding date is Required"),
  INSTRUCTION_MEDIUM: Yup.array().min(1, "Institute medium is Required"),
  GRADE_LEVELS: Yup.array().min(1, "Atleast a grade is Required"),
});

const LF = ({
  handleNavigate,
  resetFormData,
  titleAndDesNotRequired,
  disableForm,
}: {
  handleNavigate;
  resetFormData?: any;
  titleAndDesNotRequired?: boolean;
  disableForm?: boolean;
}) => {
  const { globalData } = useContext(AppContext);

  const loadInitialData = () => {
    try {
      return JSON.parse(sessionStorage.getItem("Institute")) || initialValues;
    } catch (err) {
      return initialValues;
    }
  };

  return (
    <Formik
      initialValues={loadInitialData()}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => {
        sessionStorage.setItem("Institute", JSON.stringify(values));
        handleNavigate();
      }}
    >
      {({ handleSubmit, resetForm, errors, values }) => (
        <FormWrapper
          title={"Let’s build a website that inspires everyone"}
          description={
            "A great website isn’t just the brochure, it’s your institution’s voice, credibility and first impression. Let’s create yours  "
          }
          titleLink="Why a good website needed?"
          childern={
            <Form onSubmit={handleSubmit} noValidate>
              <div className="grid grid-cols-3 gap-4 sm:grid-cols-1 md:grid-cols-1">
                <Input
                  disable={disableForm}
                  name="NAME"
                  backgroundColor="white"
                  label="Institution Name"
                  placeHolder="Enter your name here"
                  required
                />
                <Input
                  disable={disableForm}
                  name="FOUNDING_DATE"
                  type="date"
                  backgroundColor="white"
                  label="Founding Date"
                  placeHolder="DD/MM/YY"
                  required
                />
                <Input
                  disable={disableForm}
                  name="DOMAIN_NAME"
                  backgroundColor="white"
                  label="Sub Domain"
                  placeHolder="Enter Sub Domain"
                  required
                  dominCheck
                  wantButton={".soomuch.ai"}
                />
                <Dropdown
                  disable={disableForm}
                  name="INSTITUTE_TYPE"
                  label="Institution Type"
                  placeHolder="Pick Institution Type"
                  options={globalData?.InstitutionType}
                />
                <Dropdown
                  disable={disableForm}
                  name="INSTRUCTION_MEDIUM"
                  label="Medium of Instruction"
                  placeHolder="Select Medium"
                  required
                  isMulti
                  options={globalData?.Instruction_Medium}
                />
                <Input
                  disable={disableForm}
                  type="email"
                  name="EMAIL"
                  backgroundColor="white"
                  label="Email"
                  placeHolder="Enter Email"
                  required
                />
                {/* <Input
                  disable={disableForm}
                  label="Mobile Number"
                  name={`MOBILE`}
                  type="text"
                  placeHolder="Enter Mobile"
                  isMobile
                  countryCodeName={`COUNTRY_CODE`}
                  required
                /> */}
                <Dropdown
                  isCreatable
                  disable={disableForm}
                  name="BOARD_TYPE"
                  label="Board Type"
                  placeHolder="Pick Board Type"
                  options={globalData?.BoardType}
                  required
                // wantInputFieldForOtherOption
                />
                <Dropdown
                  isCreatable
                  disable={disableForm}
                  name="GRADE_LEVELS"
                  label="Grade/Class Levels"
                  placeHolder="Pick Grades"
                  required
                  isMulti
                  options={globalData?.GradeLevels}
                />
                <Dropdown
                  isCreatable
                  disable={disableForm}
                  name="ADDON_PROGRAMS"
                  label="AddOn Programs"
                  placeHolder="Select Programs"
                  isMulti
                  required
                  options={globalData?.AddonPrograms}
                />
                <Input
                  disable={disableForm}
                  label="Total Sutdents Count"
                  name={`TOTAL_STUDENTS_COUNT`}
                  type="text"
                  placeHolder="Enter Students Count"
                  required
                />
                <Input
                  disable={disableForm}
                  label="Total Faculty Count"
                  name={`TOTAL_FACULTY_COUNT`}
                  type="text"
                  placeHolder="Enter Faculty Count"
                  required
                />
                <div className="grid grid-cols-2 self-end gap-2">
                  <Input
                    disable={disableForm}
                    mapField
                    name="GOOGLE_MAP_POSITION_NAME"
                    mapName="GOOGLE_MAP_POSITION"
                    backgroundColor="white"
                    // label="Location"
                    placeHolder="Enter location manually"
                  />
                  <div className="text-[2.2vh] flex items-center gap-4">
                    <h1>Or</h1>
                    <Field name="GOOGLE_MAP_POSITION">
                      {({ field, form, meta }) => (
                        <GoogleMaps
                          disable={disableForm}
                          onLocationClick={(e) => {
                            form.setFieldValue("GOOGLE_MAP_POSITION", e);
                            form.setFieldValue(
                              "GOOGLE_MAP_POSITION_NAME",
                              e?.address || ""
                            );
                          }}
                          selectedLocation={field.value}
                          initialLocation={field.value}
                          isError={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </div>
                </div>
                <div className="col-span-2 md:col-span-1 mt-1">
                  <Field name="LOGO">
                    {({ field, form, meta }) => (
                      <FotorImageUpload
                        onChange={(item) => {
                          form.setFieldValue("LOGO", item);
                        }}
                        imageValue={field.value}
                        label="Logo"
                        customMessage=""
                        disable={disableForm}
                        isError={!!meta.touched && !!meta.error}
                      />
                    )}
                  </Field>
                </div>
                <div /* className="col-span-3" */>
                  {!disableForm && (
                    <ResetAndSubmit
                      submitToolTip={!!Object.keys(errors).length && "Please required for the next step."}
                      isError={!!Object.keys(errors).length || !values?.NAME}
                      resetForm={() => {
                        resetForm();
                        resetFormData();
                      }}
                    />
                  )}
                </div>
              </div>
            </Form>
          }
        />
      )}
    </Formik>
  );
};

export default LF;
